/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface GetTeacherBaseResponse
 */
export interface GetTeacherBaseResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetTeacherBaseResponse
     */
    teacherId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof GetTeacherBaseResponse
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof GetTeacherBaseResponse
     */
    lastName: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetTeacherBaseResponse
     */
    isActive: boolean;
}

/**
 * Check if a given object implements the GetTeacherBaseResponse interface.
 */
export function instanceOfGetTeacherBaseResponse(value: object): value is GetTeacherBaseResponse {
    if (!('teacherId' in value) || value['teacherId'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    return true;
}

export function GetTeacherBaseResponseFromJSON(json: any): GetTeacherBaseResponse {
    return GetTeacherBaseResponseFromJSONTyped(json, false);
}

export function GetTeacherBaseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTeacherBaseResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'teacherId': ApiUserTasksGetPageParameterFromJSON(json['teacherId']),
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'isActive': json['isActive'],
    };
}

export function GetTeacherBaseResponseToJSON(json: any): GetTeacherBaseResponse {
    return GetTeacherBaseResponseToJSONTyped(json, false);
}

export function GetTeacherBaseResponseToJSONTyped(value?: GetTeacherBaseResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'teacherId': ApiUserTasksGetPageParameterToJSON(value['teacherId']),
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'isActive': value['isActive'],
    };
}

